import { appConfig } from '@/shared/config/app-config'

const STORAGE_PREFIX = `${appConfig.storagePrefix}_onboarding_completed_`

export function isOnboardingCompleted(userId: string, planId: string): boolean {
  try {
    return (
      localStorage.getItem(`${STORAGE_PREFIX}${userId}:${planId}`) === 'true'
    )
  } catch {
    return false
  }
}

export function markOnboardingCompleted(userId: string, planId: string): void {
  try {
    localStorage.setItem(`${STORAGE_PREFIX}${userId}:${planId}`, 'true')
  } catch {
    // localStorage unavailable — onboarding will re-show next time
  }
}

// In-memory skip for onboarding that can't run right now (e.g. the journey
// goal failed to load): suppresses the redirect until the next page load.
const deferredPlans = new Set<string>()

export function isOnboardingDeferred(userId: string, planId: string): boolean {
  return deferredPlans.has(`${userId}:${planId}`)
}

export function deferOnboarding(userId: string, planId: string): void {
  deferredPlans.add(`${userId}:${planId}`)
}
